import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Link, useNavigate } from "react-router-dom";

export default function Register() {
  const { register, loading, error, clearError } = useAuth();
  const navigate = useNavigate();
  
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: ""
  });
  const [formError, setFormError] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setFormError("");
    clearError && clearError();
  };

  const validateForm = () => {
    if (!formData.firstName || !formData.lastName || !formData.email || !formData.password) {
      return "Tous les champs sont obligatoires";
    }

    if (!formData.email.includes('@')) {
      return "Email invalide";
    }

    if (formData.password.length < 6) {
      return "Le mot de passe doit contenir au moins 6 caractères";
    }

    if (formData.password !== formData.confirmPassword) {
      return "Les mots de passe ne correspondent pas";
    }

    return null;
  };

  // ✅ CORRECTION : handleRegister doit être une fonction
  const handleRegister = async (e) => {
    e.preventDefault();
    
    const validationError = validateForm();
    if (validationError) {
      setFormError(validationError);
      return;
    }

    const userData = {
      name: `${formData.firstName} ${formData.lastName}`,
      email: formData.email,
      password: formData.password
    };

    console.log('🔄 Tentative d\'inscription...');
    
    if (typeof register === 'function') {
      const result = await register(userData);
      
      if (result && result.success) {
        alert("Compte créé avec succès !");
        navigate("/");
      }
    } else {
      console.error('❌ register n\'est pas une fonction');
      setFormError('Erreur système - veuillez recharger la page');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#fffaf3] py-12 px-4">
      <div className="bg-white p-8 rounded-2xl shadow-lg w-full max-w-md border border-[#e8e2d1]">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-serif font-light text-[#2f2a1e] mb-2">
            Créer un compte
          </h2>
          <p className="text-[#7a7250] text-sm">
            Rejoignez notre communauté
          </p>
        </div>

        {(error || formError) && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-6">
            {error || formError}
          </div>
        )}
        
        {/* ✅ CORRECTION : onSubmit={handleRegister} */}
        <form onSubmit={handleRegister} className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-[#2f2a1e] text-sm font-light mb-2">
                Prénom *
              </label>
              <input 
                type="text" 
                name="firstName"
                placeholder="Votre prénom" 
                value={formData.firstName} 
                onChange={handleChange}
                className="w-full p-3 border border-[#e8e2d1] rounded-lg focus:outline-none focus:border-[#d0b125] transition placeholder-[#7a7250]"
                required
                disabled={loading}
              />
            </div>
            
            <div>
              <label className="block text-[#2f2a1e] text-sm font-light mb-2">
                Nom *
              </label>
              <input 
                type="text" 
                name="lastName"
                placeholder="Votre nom" 
                value={formData.lastName} 
                onChange={handleChange}
                className="w-full p-3 border border-[#e8e2d1] rounded-lg focus:outline-none focus:border-[#d0b125] transition placeholder-[#7a7250]"
                required
                disabled={loading}
              />
            </div>
          </div>

          <div>
            <label className="block text-[#2f2a1e] text-sm font-light mb-2">
              Email *
            </label>
            <input 
              type="email" 
              name="email"
              placeholder="votre@email.com" 
              value={formData.email} 
              onChange={handleChange}
              className="w-full p-3 border border-[#e8e2d1] rounded-lg focus:outline-none focus:border-[#d0b125] transition placeholder-[#7a7250]"
              required
              disabled={loading}
            />
          </div>
          
          <div>
            <label className="block text-[#2f2a1e] text-sm font-light mb-2">
              Mot de passe *
            </label>
            <input 
              type="password" 
              name="password"
              placeholder="Minimum 6 caractères" 
              value={formData.password} 
              onChange={handleChange}
              className="w-full p-3 border border-[#e8e2d1] rounded-lg focus:outline-none focus:border-[#d0b125] transition placeholder-[#7a7250]"
              required
              disabled={loading}
              minLength="6"
            />
          </div>

          <div>
            <label className="block text-[#2f2a1e] text-sm font-light mb-2">
              Confirmer le mot de passe *
            </label>
            <input 
              type="password" 
              name="confirmPassword"
              placeholder="Retapez votre mot de passe" 
              value={formData.confirmPassword} 
              onChange={handleChange}
              className="w-full p-3 border border-[#e8e2d1] rounded-lg focus:outline-none focus:border-[#d0b125] transition placeholder-[#7a7250]"
              required
              disabled={loading}
            />
          </div>

          <button 
            type="submit" 
            disabled={loading}
            className="w-full bg-[#2f2a1e] text-white py-4 rounded-lg hover:bg-[#d0b125] transition duration-300 font-light text-lg disabled:opacity-50 disabled:cursor-not-allowed mt-4"
          >
            {loading ? (
              <span className="flex items-center justify-center">
                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Création...
              </span>
            ) : (
              "Créer mon compte"
            )}
          </button>
        </form>

        <div className="mt-8 text-center">
          <p className="text-[#7a7250] text-sm">
            Déjà un compte ?{" "}
            <Link 
              to="/login" 
              className="text-[#d0b125] hover:underline font-light transition"
            >
              Se connecter
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}